// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3wWk_","col":"Table_col__dv3fh","fulfillmentStatus":"Table_fulfillmentStatus__2TBAW","emailCol":"Table_emailCol__1C3Op"};